var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center w-75 mx-auto"},[_c('div',{staticClass:"mt-5"},[_c('img-default',{attrs:{"custom_class":"mb-3"}}),_vm._v(" "),_c('p',{staticClass:"pt-3 heading-4 text-22 mb-2"},[_vm._v("Access Denied")]),_vm._v(" "),_c('p',{staticClass:"body-2 mb-4 w-75 mx-auto"},[_vm._v("This area is for development only")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a125efe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/general/DevelopmentOnly.vue
// module id = null
// module chunks = 